import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Icon, Table } from 'semantic-ui-react';
import TableWrapper from '@/components/table/TableWrapper';
import DataManagementDictionaryIcon from './DataManagementDictionaryIcon';

const ValidateDataResultsDictionaryHeader = ({
  dictionaryName,
  loading,
  valid,
  validate,
}) => {
  const intl = useIntl();
  return (
    <TableWrapper unstackable compact solid sticky attached="top">
      <Table.Header>
        <Table.Row className="aridhia-validate-data-results-dictionary-header">
          <Table.HeaderCell>
            <DataManagementDictionaryIcon valid={valid} isLoading={loading} />
            {dictionaryName}
          </Table.HeaderCell>
          <Table.HeaderCell collapsing>
            <Button primary onClick={validate} size="mini">
              <Icon name="play" className="primary" alt={intl.formatMessage({ id: 'actions.validate' })} />
              <FormattedMessage id="actions.validate" />
            </Button>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    </TableWrapper>
  );
};

export default ValidateDataResultsDictionaryHeader;
